import { type ReactNode } from 'react';
import { t } from '../../i18n';
import { Button } from '../Button';

export interface ErrorStateProps {
  title?: ReactNode;
  description?: ReactNode;
  onRetry?: () => void;
  retryLabel?: ReactNode;
  className?: string;
}

export function ErrorState({
  title = t('errorState.title'),
  description,
  onRetry,
  retryLabel = t('errorState.retry'),
  className,
}: ErrorStateProps) {
  return (
    <div
      className={[
        'flex flex-col items-center justify-center text-center p-8 bg-state-error-bg text-state-error-fg rounded-control',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      role="alert"
    >
      <h3 className="text-heading-3">{title}</h3>
      {description && <p className="mt-2 text-body-sm">{description}</p>}
      {onRetry && (
        <div className="mt-6">
          <Button variant="secondary" onClick={onRetry}>
            {retryLabel}
          </Button>
        </div>
      )}
    </div>
  );
}
